import { Piece } from '../../Piece';
import { GameState, IPiece, Mode, PieceType, State } from '../../types';
import { copyState } from '../AstraAI/AstraRules';

// Allowlist: never spread live state/piece metadata into Blind's search input.
// In particular, enemy isKing, enemy king type, UI config and analysis are absent.
const publicFlags = ['isZombified','isFainted','isEntangled','isShadowed','isShadow',
  'isZombieInkShadow','zombieInkTargetColor','isInfected','hasCharged','hasMoved',
  'hasShed','hasLilyJumped','isMeadowed','isRiding','isHousing','isLone','isDormant',
  'entangledPieceId'] as const;
export const stripKings = (fen:string):string => fen.replace(/[♛♕]/gu,'');

export function observeForBlind(input:GameState):GameState {
  const ownLight=input.isLightTurn;
  const board=input.board.map(row=>row.map(square=>({Pieces:square.Pieces.map(p=>{
    const clean=new Piece(p.type,p.isLight,p.direction);
    clean.id=p.id;
    clean.isKing=p.isLight===ownLight ? p.isKing : false;
    for(const flag of publicFlags) (clean as any)[flag]=p[flag];
    clean.poisonedStatus={isPoisoned:!!p.poisonedStatus?.isPoisoned,removeOnTurn:p.poisonedStatus?.removeOnTurn};
    clean.zombifiedStatus={isZombified:!!p.zombifiedStatus?.isZombified,removeOnTurn:p.zombifiedStatus?.removeOnTurn};
    return clean;
  })})));
  const ownKing=board.flatMap(r=>r.flatMap(s=>s.Pieces)).find(p=>p.isLight===ownLight && p.isKing)?.type;
  return {board,mode:input.mode===Mode.TestAI?Mode.TestAI:Mode.AI,state:State.Playing,
    isLightTurn:ownLight,turnCount:input.turnCount,
    lightKing:ownLight?ownKing:undefined,darkKing:ownLight?undefined:ownKing,
    fenHistory:(input.fenHistory||[]).map(stripKings),
    activeBonusTurnPieceId:input.activeBonusTurnPieceId,skipTurnChange:input.skipTurnChange,
    shadowsActive:input.shadowsActive,lastSwingMonkeyId:input.lastSwingMonkeyId,
    lastSwingFromPosition:input.lastSwingFromPosition?{...input.lastSwingFromPosition}:null,
    lastSwingToPosition:input.lastSwingToPosition?{...input.lastSwingToPosition}:null};
}

export interface KingWorld {state:GameState; probability:number; candidateId:string; type:PieceType}
export function kingWorlds(observation:GameState):KingWorld[] {
  const enemies=observation.board.flatMap(r=>r.flatMap(s=>s.Pieces)).filter(p=>
    p.isLight!==observation.isLightTurn && !p.isShadow && p.type!==PieceType.Virus);
  // V1 deliberately has no "a player would never expose their king" prior.
  // Captured candidates disappear when play continues; every survivor stays possible.
  return enemies.map(candidate=>{
    const state=copyState(observation);
    state.board.forEach(r=>r.forEach(s=>s.Pieces.forEach(p=>{
      if(p.isLight!==observation.isLightTurn) p.isKing=p.id===candidate.id;
    })));
    if(observation.isLightTurn)state.darkKing=candidate.type;else state.lightKing=candidate.type;
    return {state,probability:1/enemies.length,candidateId:candidate.id,type:candidate.type};
  });
}
